"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _gbp = _interopRequireDefault(require("gbp"));
var _table = _interopRequireDefault(require("../../../../../core/table"));
var _input = _interopRequireDefault(require("../../../../../core/input"));
var _alert = _interopRequireDefault(require("../../../../../core/alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("td", null, "Original Payment Amount");
var _ref2 = /*#__PURE__*/_react.default.createElement("th", null, "Remaining Payment Available for Refunds");
var _ref3 = /*#__PURE__*/_react.default.createElement("th", null);
var _ref4 = /*#__PURE__*/_react.default.createElement("td", null, "Refund Due (includes late fees and feeAdjustments)");
var _ref5 = /*#__PURE__*/_react.default.createElement("td", null);
class ReviewRefundCalculation extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      availableFunds: null
    });
    _defineProperty(this, "_displayDateTime", value => {
      if (!value) return '';
      const datePart = value.split('T')[0];
      const timePart = value.split('T')[1].split('.')[0];
      return (0, _occasion.default)(datePart, 'D MMM YYYY') + ' at ' + timePart.substring(0, 5);
    });
  }
  componentWillMount() {
    // Calulate refund based on due and available
    let totalRefundedToDate = 0;
    this.props.entry.payment.refunds.forEach(refund => {
      totalRefundedToDate += refund.refundedByClub;
    });
    const availableFunds = this.props.entry.payment.expectedForClub - totalRefundedToDate;
    const refundAmount = this.props.entry.payment.refundDue > availableFunds ? availableFunds : this.props.entry.payment.refundDue;
    this.setState({
      availableFunds
    });
    this.props.onSetRefundAmount(refundAmount);
  }
  render() {
    const payment = this.props.entry.payment;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref, /*#__PURE__*/_react.default.createElement("td", null, this._displayDateTime(payment.paidDate)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(payment.expectedForClub))), payment.refunds.map(refund => /*#__PURE__*/_react.default.createElement("tr", {
      key: refund.id
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, refund.refundStatusDescription), /*#__PURE__*/_react.default.createElement("td", null, this._displayDateTime(refund.refundDate)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right text-xs-danger"
    }, (0, _gbp.default)(refund.refundedByClub)))), /*#__PURE__*/_react.default.createElement("tr", null, _ref2, _ref3, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(this.state.availableFunds))), /*#__PURE__*/_react.default.createElement("tr", null, _ref4, _ref5, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(payment.refundDue))))), payment.refundDue === this.props.refundAmount ? null : /*#__PURE__*/_react.default.createElement(_alert.default, null, "There is insufficient payment to make a full refund - ", (0, _gbp.default)(this.props.refundAmount), " will be refunded."));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref6 = {
  id: true,
  refundDate: true,
  refundedByClub: true,
  refundStatusDescription: true
};
var _default = exports.default = (0, _reactBicycle.connect)(ReviewRefundCalculation, props => ({
  ["entry(entryID:" + JSON.stringify(props.entryID) + ")"]: {
    payment: {
      expectedForClub: true,
      paidDate: true,
      refunds: _ref6,
      ["refundDue(entryIDsToRefund:" + JSON.stringify(props.selectedEntryIDs.join(',')) + ")"]: true
    }
  }
}));